import { render } from "./tab-learn-subject.vue?vue&type=template&id=2bfdf44f&scoped=true"
import script from "./tab-learn-subject.vue?vue&type=script&lang=js"
export * from "./tab-learn-subject.vue?vue&type=script&lang=js"

import "./tab-learn-subject.vue?vue&type=style&index=0&id=2bfdf44f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfdf44f"]])

export default __exports__